import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const Ingridient = ({ ingridient, measures }) => {
  let ingridientStr = `${ingridient.name} - ${ingridient.pivot.weight} `;
  if (ingridient.pivot.weight === '0') ingridientStr = `${ingridient.name} - `;
  if (ingridient.pivot && ingridient.pivot.measure_id) {
    const measureObj = measures.find((measure) => measure.id === ingridient.pivot.measure_id);
    ingridientStr += measureObj ? measureObj.measure : '';
  }

  return <IngredientInfoWrap>{ingridientStr}</IngredientInfoWrap>;
};

const mapStateToProps = (state) => ({
  measures: state.dishSearch.measures,
});

export default connect(mapStateToProps)(Ingridient);

const IngredientInfoWrap = styled.div`
  margin: 3px 0px;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/Ingridient.jsx